import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <nav className={`navbar ${scrolling && !showMenu ? 'navbar-visible' : ''}`}>
      <Link to="/" className="logo-link">
        <img src="/images/logo.png" alt="Logo" className="logo" />
      </Link>
      
      <div className="menu-icon" onClick={toggleMenu}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>

      {showMenu && (
        <div className="overlay">
          <ul className="menu-options">
            <li><Link to="/" onClick={toggleMenu}>Inicio</Link></li>
            <li><Link to="/nosotros" onClick={toggleMenu}>Nosotros</Link></li>
            <li><Link to="/servicios" onClick={toggleMenu}>Servicios</Link></li>
            <li><Link to="/soluciones" onClick={toggleMenu}>Soluciones</Link></li>
            <li><Link to="/casos-de-exito" onClick={toggleMenu}>Casos de Éxito</Link></li>
            <li><Link to="/blog" onClick={toggleMenu}>Blog</Link></li>
            <li><Link to="/contacto" className="highlighted" onClick={toggleMenu}>Contacto</Link></li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
